import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import { tr } from '../utils/locale';
import Icon from '../Icon/Icon';

export default class Stepper extends Component {
    render() {
        const { steps, current, ...rest } = this.props;
        const stepsComponents = [];
        for (let i = 1; i <= steps; i++) {
            stepsComponents.push(
                <Icon
                    key={`step_${i}`}
                    className={cl(i <= current ? 'stepper--current' : null)}
                    icon={i <= current ? 'dot-fill' : 'dot'}
                    size={i === current ? 48 : 28}
                    title={i <= current ? tr('Finished step') : tr('Coming step')}
                />
            );
        }
        return (
            <div className={cl('stepper')} {...rest}>
                {stepsComponents}
            </div>
        );
    }
}

Stepper.propTypes = {
    steps: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
};
